import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { DescriptionField, If } from "components/support";

import _ from "lodash";

class CustomerGeographicInfo extends Component {
  render() {
    const { customer, fields } = this.props;
    const address = customer.address || {};

    return (
      <div className="grid-container">
        <Row>
          <If
            test={_.findIndex(fields, { show: false, key: "zipcode" }) === -1}
          >
            <Col xs={12} lg={3}>
              <DescriptionField
                label="CEP"
                value={address.zipcode}
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
              />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "state" }) === -1}>
            <Col xs={12} lg={2}>
              <DescriptionField label="Estado" value={address.state} />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "city" }) === -1}>
            <Col xs={12} lg={3}>
              <DescriptionField label="Cidade" value={address.city} />
            </Col>
          </If>

          <If
            test={
              _.findIndex(fields, { show: false, key: "neighborhood" }) === -1
            }
          >
            <Col xs={12} lg={4}>
              <DescriptionField label="Bairro" value={address.neighborhood} />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "street" }) === -1}>
            <Col xs={12} lg={8}>
              <DescriptionField label="Logradouro" value={address.street} />
            </Col>
          </If>

          <If test={_.findIndex(fields, { show: false, key: "number" }) === -1}>
            <Col xs={12} lg={4}>
              <DescriptionField label="Número" value={address.number} />
            </Col>
          </If>

          <If
            test={
              _.findIndex(fields, { show: false, key: "complement" }) === -1
            }
          >
            <Col xs={12}>
              <DescriptionField
                label="Complemento"
                value={address.complement}
              />
            </Col>
          </If>
        </Row>
      </div>
    );
  }
}

export default CustomerGeographicInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/geographic-info/index.jsx